import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/vYIwDXKFZz5Bz6aABZ9q/locations/XrqQDM4xS5psyELMCYRq`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="80%"
                  maxWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/vYIwDXKFZz5Bz6aABZ9q/locations/XrqQDM4xS5psyELMCYRq`}
            >
              <CFView hover pulsate>
                <CFImage src={orderPickupButton} maxWidth="255px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
